<template>
  <div class="touxi">
    <div class="header">
      <titleCard title="Setting up of Hemodialysis Unit" class="animate__animated wow animate__fadeInUp"></titleCard>
      <p class="header-title animate__animated wow animate__fadeInUp">Conform to the national policy, Provide flexibility to respond to emerging opportunities. One-stop service of establishment of hemodialysis units, including Project funding, Equipment supplying, Technical Support, Staff hiring, business operating.
      </p>
      <div class="header-box">
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="0.6s">
          <div class="pic-box"><img src="../../assets/image/innovatc/touxi1.webp"></div>
          <div class="text-box">
            <div class="icon"><img src="../../assets/image/innovatc/touxi4.webp" alt=""></div>
            <p>All services are followed by unified and standardized procedures</p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="0.8s">
          <div class="pic-box"><img src="../../assets/image/innovatc/touxi2.webp"></div>
          <div class="text-box">
            <div class="icon"><img src="../../assets/image/innovatc/touxi5.webp" alt=""></div>
            <p>Professional teamwork and collaboration</p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1s">
          <div class="pic-box"><img src="../../assets/image/innovatc/touxi3.webp"></div>
          <div class="text-box">
            <div class="icon"><img src="../../assets/image/innovatc/touxi6.webp" alt=""></div>
            <p>Hemodialysis Intelligent Management System</p>
          </div>
        </div>
      </div>
    </div>
    <div class="main animate__animated wow animate__fadeIn">
      <div class="title">
        <div class="titleCard">
          <p>Comprehensive service provider of Hemodialysis</p>
          <span></span>
        </div>
      </div>
      <div class="main-boxs">
        <div class="box animate__animated wow animate__fadeInLeft" data-wow-duration="1.6s">
          <div class="pic"><img src="../../assets/image/innovatc/touxi4.webp"></div>
          <h4>Planning</h4>
          <h3>Feasibility Analysis, Proposal,Preparation</h3>
          <span></span>
          <p>Market Research <br> Site selection, Design, Construction, Acceptance</p>
        </div>
        <div class="box animate__animated wow animate__fadeInLeft" data-wow-duration="1.4s">
          <div class="pic"><img src="../../assets/image/innovatc/touxi5.webp"></div>
          <h4>Preparation</h4>
          <h3> Supply-chain service, Clinical Preparation, Acceptance</h3>
          <span></span>
          <p>Procurement, Medical Training, Drafting & Documentation Information Management Platform electronic patient database Quality control and Hospital Infection Control </p>
        </div>
        <div class="box animate__animated wow animate__fadeInLeft" data-wow-duration="1.2s">
          <div class="pic"><img src="../../assets/image/innovatc/touxi6.webp"></div>
          <h4>Operation</h4>
          <h3>Operational Support<br>&nbsp;</h3>
          <span></span>
          <p>With Local Assistance From Senior Medical Staff Health Education. guidance on arrangements for responding to emergency situations</p>
        </div>
      </div>
    </div>
    <div class="footer animate__animated wow animate__fadeInUp">
      <div class="footer-title">
        <titleCard title="Service Case"></titleCard>
      </div>
      <div class="footer-content">
        <el-carousel :interval="3000" arrow="always" type="card" trigger='click' :autoplay='IsAutoplay'>
          <el-carousel-item v-for="(item,index) in fuwuList" :key="index">
            <img :src="item" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="footer-text animate__animated wow animate__fadeIn">
      <h4>To serve for the purpose, dedicated to discipline construction, technical innovation and quality service, our mission is to improve the quality of life for renal patients by revitalising them both physically and emotionally.</h4>
    </div>
    <footerCard name="Mr Ji" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'

export default {
  data() {
    return {
      IsAutoplay: false,
      screenWidth: document.body.clientWidth,
      fuwuList: [
        require('../../assets/image/innovatc/lunbo/lunbo1.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo2.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo3.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo4.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo5.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo6.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo7.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo8.webp'),
        require('../../assets/image/innovatc/lunbo/lunbo9.webp'),
      ]
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {
    if (this.screenWidth < 540) {
      this.IsAutoplay = true
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.touxi {
  .header {
    padding: 1.3684rem 0 1.0526rem;
    .header-title {
      margin: 0;
      padding: 0.5263rem 0 0.7368rem 0;
      text-align: center;
      width: 50%;
      margin: 0 auto;
      color: #000;
      font-size: 0.2526rem;
      line-height: 0.5263rem;
      @media screen and (max-width: 540px) {
        line-height: 1.2632rem;
        width: 80%;
        font-size: 13px;
        padding: 30px 0;
      }
    }
    .header-box {
      display: flex;
      justify-content: center;
      padding-bottom: 2.0526rem;
      .box {
        width: 5.4737rem;
        margin: 0 0.0842rem;
        @media screen and (max-width: 540px) {
          // height: 85px;
          width: 30%;
        }
        .pic-box {
          height: 3.7895rem;
          margin-bottom: 0.2947rem;
          @media screen and (max-width: 540px) {
            height: 85px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text-box {
          height: 2.3158rem;
          border: 1px solid #eaeaea;
          display: flex;
          justify-content: center;
          align-items: center;
          @media screen and (max-width: 540px) {
            height: 180px;
            flex-wrap: wrap;
            // display: block;
          }
          .icon {
            width: 0.8105rem;
            height: 0.8105rem;
            padding:0 0.3895rem;
            @media screen and (max-width: 540px) {
              width: 38px;
              height: 38px;
              padding-right: 0;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          p {
            font-size: 0.2458rem;
            color: #333333;
            flex: 1;
            font-weight: 700;
            padding-right: 10px;
            @media screen and (max-width: 540px) {
              font-size: 15px;
              padding: 0 20px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .main {
    height: 10.3158rem;
    @media screen and (max-width: 540px) {
      height: 500px;
    }
    background: url('../../assets/image/innovatc/touxi-bg.webp') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 1.5789rem;
    .title {
      padding: 1.2632rem 0 1.1579rem 0;
      .titleCard {
        text-align: center;
        p {
          padding-bottom: 0.3789rem;
          font-size: 0.4421rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.0526rem;
          @media screen and (max-width: 540px) {
            font-size: 21px;
          }
        }
        span {
          margin: 0 auto;
          position: relative;
          display: block;
          width: 3.0947rem;
          height: 0.0421rem;
          background-color: #ffffff;
          @media screen and (max-width: 540px) {
            width: 9.4737rem;
            height: 0.1263rem;
          }
        }
        span::after {
          content: '';
          position: absolute;
          left: 50%;
          margin-left: -0.2947rem;
          bottom: -0.0105rem;
          width: 0.5895rem;
          height: 0.0842rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 1.6842rem;
            height: 0.2211rem;
            bottom: -0.0316rem;
            margin-left: -0.8421rem;
          }
        }
      }
    }
    .main-boxs::-webkit-scrollbar {
      display: none;
    }
    .main-boxs {
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        overflow-x: scroll;
        justify-content: left;
        margin: 0 10px;
      }

      .box {
        width: 4.7158rem;
        box-shadow: 1px 1px 1px rgba(255, 255, 255, 0.658);
        height: 5.6842rem;
        margin: 0 0.1263rem;
        background-color: #fff;
        text-align: center;
        @media screen and (max-width: 540px) {
          height: 300px;
          flex-basis: 250px;
          flex-shrink: 0;
          margin: 0 10px;
        }
        .pic {
          margin: 0 auto;
          padding-top: 0.2842rem;
          width: 1.1368rem;
          height: 1.1368rem;
          @media screen and (max-width: 540px) {
            width: 54px;
            height: 54px;
            padding-top: 18px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
        h4 {
          color: #333333;
          font-size: 0.2947rem;
          font-weight: 700;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        h3 {
          font-weight: 700;
          font-size: 0.2526rem;
          color: #0ca6eb;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
        span {
          display: block;
          margin: 0 auto;
          background-color: #0ca6eb;
          height: 0.0105rem;
          width: 80%;
          margin-bottom: 0.6316rem;
        }
        p {
          font-size: 0.2026rem;
          color: #666666;
          padding: 0 10px;
          @media screen and (max-width: 540px) {
            line-height: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .footer {
    .footer-title {
      padding: 0 0 1.7895rem 0;
    }
    .footer-content {
      padding: 0 2.7158rem;
      height: 4.5895rem;
      padding-bottom: 2rem;
      @media screen and (max-width: 540px) {
        height: 160px;
        padding: 0;
        padding-bottom: 54px;
      }
      .el-carousel__item img {
        height: 100%;
        width: 100%;
      }
      /deep/ .el-carousel__container {
        height: 90%;
      }
      /deep/ .el-carousel__arrow {
        @media screen and (max-width: 540px) {
          display: none;
        }
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
      }
      /deep/ .el-carousel__indicators {
        @media screen and (max-width: 540px) {
          display: none;
        }
      }
      /deep/ .el-carousel--horizontal {
        height: 100%;
      }
      // /deep/ .el-carousel__arrow--left {
      //   left: -80px;
      // }
      // /deep/ .el-carousel__arrow--right {
      //   right: -80px;
      // }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        padding-top: 0.3158rem;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
  }
  .footer-text {
    height: 2.2105rem;
    background: url('../../assets/image/innovatc/touxi-footer.webp') no-repeat;
    background-size: 100% 100%;
    margin-bottom: -0.0211rem;
    text-align: center;
    color: #fff;
    padding: 0 2rem;
    font-size: 0.3579rem;
    @media screen and (max-width: 540px) {
      height: 190px;
      font-size: 15px;
    }
    h4 {
      font-weight: 500;
      margin: 0;
      padding: 0.3947rem 0 0.1053rem 0;
      @media screen and (max-width: 540px) {
        padding: 33px 0 10px 0;
      }
    }
    h3 {
      font-weight: 800;
      margin: 0;
    }
  }
}
</style>
